import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from 'components/App';
import { onLCP } from 'web-vitals';

//import Rails from "@rails/ujs";

//import '@/channels/index.js'

// Move web-vitals monitoring outside DOMContentLoaded
try {
  console.log('Initializing web-vitals monitoring...');
  
  onLCP((metric) => {
    try {
      // Safe logging with checks
      console.group('LCP Measurement');
      console.log('Final:', Boolean(metric.isFinal));
      console.log('Value:', metric.value);
      console.log('Element:', metric.element || 'No element');
      console.log('Element HTML:', metric.element?.outerHTML || 'No HTML');
      console.log('Start Time:', metric.startTime || 'No timestamp');
      console.log('Raw metric:', metric);
      console.groupEnd();

      // Skip if no value
      if (!metric.value) {
        console.log('Skipping measurement with no value');
        return;
      }

      const shopOrigin = document.getElementById("shopify-app-init")?.dataset?.shopOrigin;
      console.log('Shop Origin:', shopOrigin);

      if (!shopOrigin) {
        console.warn('No shopOrigin found');
        return;
      }

      const body = {
        page_url: window.location.pathname,
        value: metric.value,
        shop_domain: shopOrigin
      };

      console.log('About to send metrics with:', body);

      fetch('/metrics', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      })
      .then(response => {
        console.log('Response received:', response);
        console.log('Response status:', response.status);
        return response.text().then(text => {
          console.log('Response text:', text);
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${text}`);
          }
          return text;
        });
      })
      .then(() => {
        console.log('Metrics sent successfully');
      })
      .catch(error => {
        console.error('Error sending metrics:', error);
        console.error('Full error details:', {
          message: error.message,
          stack: error.stack
        });
      });
    } catch (innerError) {
      console.error('Error processing LCP measurement:', innerError);
    }
  }, {
    reportAllChanges: true  // Add this back
  });
} catch (error) {
  console.error('Error initializing web-vitals:', error);
}

// Initialize the app when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log("Initializing React app");
  const data = document.getElementById("shopify-app-init").dataset;
  const domNode = document.getElementById('root');

  // Initialize AppBridge
  const AppBridge = window["app-bridge"];
  const createApp = AppBridge.default;
  window.app = createApp({
    apiKey: data.apiKey,
    host: data.host,
  });

  // Create React root and render app
  const root = createRoot(domNode);
  root.render(
    <StrictMode>
      <App
        shop_domain={data.shopOrigin}
        proxy_path={data.proxyPath}
        mapbox_admin_token={data.mapboxAdminToken}
        api_key={data.apiKey}
        host={data.host}
        production={data.production}
        plan={data.plan}
        app_proxy_landing_url={data.appProxyLandingUrl}
        app_proxy_directory_url={data.appProxyDirectoryUrl}
        enabled_features={data.enabledFeatures}
        language_translate_icon_url={data.languageTranslateIconUrl}
      />
    </StrictMode>
  );
});
